import {cloneDeep, isEmpty} from 'lodash';
import {
	GET_ALL_CONTROLS,
	GET_CONTROL_BY_ID,
	GET_FILTERED_CONTROLS,
	DELETE_CONTROL_BY_ID,
	CLEAR_CONTROL,
	GET_UNRELATED_CONTROLS_COUNT,
	GET_CONTROLS_WITH_NO_DESIGN_EFFECTIVENESS_COUNT,
	UNRELATE_CONTROL_FROM_WCGW,
	LINK_CONTROL_TO_WCGW,
	LINK_CONTROL_RELATE_TASK,
	UNLINK_CONTROL_RELATE_TASK,
	GET_ALL_ORPHANED_CONTROLS,
	CREATE_CONTROL,
	UPDATE_CONTROL,
	SET_LOADER_FOR_RELATED_TASK,
	ADD_CONTROL_RELATED_TASK,
	PATCH_CONTROL,
	CLEAR_FILTERED_CONTROLS
} from '../../actions/actiontypes';
import {HttpStatusCodes, controlDesignEffectivenessValues, pagingOptions200} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import initialstate from '../initialstate';

export function controlReducer(state = initialstate.controls, action) {
	const deleteControlFromState = (controlId) => {
		let tempState = _.cloneDeep(state);
		tempState.data = tempState?.data?.filter((control) => control.id !== Number(controlId));
		return tempState;
	};

	function updateRelatedTask(payload, isSorting = false) {
		const controlsIndex = state.data?.findIndex((control) => control.id === payload.controlId);
		if (controlsIndex !== -1) {
			let updatedtasks = cloneDeep(state);
			updatedtasks.data[controlsIndex].relatedTasks.push(payload);
			if (isSorting) {
				updatedtasks.data[controlsIndex].relatedTasks.sort((a, b) => {
					const aValue = a.taskDisplayName;
					const bValue = b.taskDisplayName;
					return aValue.localeCompare(bValue, undefined, {numeric: true, sensivity: 'base'});
				});
			}
			updatedtasks.data[controlsIndex].addTaskLoader = false;
			return updatedtasks;
		}
		return state;
	}

	switch (action.type) {
		case GET_ALL_CONTROLS: {
			const response = action.response;
			return {...state, ...(response.controls || response)};
		}

		case GET_ALL_ORPHANED_CONTROLS: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					orphanedControls: action.response
				};
			}
			return state;
		}
		case GET_CONTROL_BY_ID: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					selectedControl: action.response
				};
			} else if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteControlFromState(action.controlId); // this is to remove the control from the list if it is not found (concurrency scenario)
			}
			return state;
		}

		case GET_FILTERED_CONTROLS: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					filteredControls: action.response
				};
			}
			return state;
		}

		case CLEAR_FILTERED_CONTROLS: {
			return {
				...state,
				filteredControls: null
			};
		}

		case DELETE_CONTROL_BY_ID: {
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteControlFromState(action.controlId);
			}
			if (isApiResponseOk(action)) {
				let tempState = deleteControlFromState(action.controlId);

				return {
					...tempState
				};
			}
			return state;
		}

		case CLEAR_CONTROL: {
			return {
				...state,
				selectedControl: null
			};
		}

		case GET_UNRELATED_CONTROLS_COUNT:
			return state;

		case GET_CONTROLS_WITH_NO_DESIGN_EFFECTIVENESS_COUNT:
			return {
				...state,
				controlHasNoDesignEffectivenssCount: action.response?.totalEntityCount
			};

		case UNRELATE_CONTROL_FROM_WCGW: {
			if (isApiResponseOk(action)) {
				return state;
			} else {
				return {
					...state,
					errorMessage: action.meta.auth.error
				};
			}
		}

		case LINK_CONTROL_TO_WCGW: {
			if (isApiResponseOk(action)) {
				return state;
			}
			return state;
		}
		case ADD_CONTROL_RELATED_TASK:
			if (action.taskAttributes) {
				return updateRelatedTask(action.taskAttributes);
			}
			return state;

		case LINK_CONTROL_RELATE_TASK:
			if (action.taskAttributes && isApiResponseOk(action)) {
				return updateRelatedTask(action.taskAttributes, true);
			}
			return state;

		case UNLINK_CONTROL_RELATE_TASK: {
			if (action.taskAttributes && isApiResponseOk(action)) {
				const controlsData = cloneDeep(state);
				const control = controlsData?.data?.find((control) => control.id === action.taskAttributes.controlId);
				if (control) {
					let relatedTaskIndex = control.relatedTasks.findIndex(
						(task) => task.id === action.taskAttributes.taskId || task.taskId === action.taskAttributes.taskId
					);
					if (relatedTaskIndex !== -1) {
						control.relatedTasks.splice(relatedTaskIndex, 1);
					}
				}
				return controlsData;
			}
			return state;
		}

		case CREATE_CONTROL: {
			if (isApiResponseOk(action)) {
				let controls = cloneDeep(state);
				return {
					...controls,
					selectedControl: action.response,
					newControl: action.response
				};
			}
			return state;
		}

		case UPDATE_CONTROL: {
			if (!isEmpty(action.response)) {
				let newState = cloneDeep(state);
				const editIndex = newState?.data?.findIndex((control) => control.id === action.response.id);

				if (editIndex !== -1) {
					newState.data[editIndex] = {...action.response};
				}
				return {
					...newState
				};
			} else if (action?.error?.response?.status === HttpStatusCodes.BadRequest) {
				return deleteControlFromState(action?.meta?.api?.data?.controlId); // this is to remove the control from the list if it is not found (concurrency scenario)
			}
			return state;
		}

		case SET_LOADER_FOR_RELATED_TASK: {
			if (action.control) {
				return {
					...state,
					data: state.data.map((control) => {
						if (control.id === action.control.id) {
							return {
								...control,
								addTaskLoader: true
							};
						}
						return control;
					})
				};
			}
			return state;
		}

		case PATCH_CONTROL: {
			if (isApiResponseOk(action)) {
				let newState = cloneDeep(state);
				let count = null;
				if (newState?.filteredControls) {
					newState.filteredControls.data?.map((control) => {
						if (control.id === action.response.id) {
							if (
								(control.controlDesignEffectivenessTypeId === null ||
									control.controlDesignEffectivenessTypeId === controlDesignEffectivenessValues.none) &&
								(action.response.controlDesignEffectivenessTypeId === controlDesignEffectivenessValues.effective ||
									action.response.controlDesignEffectivenessTypeId === controlDesignEffectivenessValues.inEffective)
							) {
								count = state.controlHasNoDesignEffectivenssCount - 1;
							}
						}
					});
				}
				return {
					...state,
					data: state.data?.map((control) => {
						if (control.id === action.response.id) {
							control = {...control, ...action.response};
						}
						return control;
					}),
					filteredControls: {
						...state.filteredControls,
						data: state.filteredControls?.data?.map((control) => {
							if (control.id === action.response.id) {
								control = {...control, ...action.response};
							}
							return control;
						})
					},
					controlHasNoDesignEffectivenssCount: count !== null ? count : state.controlHasNoDesignEffectivenssCount
				};
			}
			return state;
		}

		default:
			return state;
	}
}
